import { render, staticRenderFns } from "./HomeCTA.vue?vue&type=template&id=0199e614&scoped=true&"
import script from "./HomeCTA.vue?vue&type=script&lang=js&"
export * from "./HomeCTA.vue?vue&type=script&lang=js&"
import style0 from "./HomeCTA.vue?vue&type=style&index=0&id=0199e614&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0199e614",
  null
  
)

export default component.exports